import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

const TAG = 'AmapHeatmap';

export namespace AMapHeatmap {
  export interface Options {
    /**
     * ç­åå¾ä¸­åä¸ªç¹çåå¾ï¼é»è®¤ï¼30ï¼åä½ï¼pixel
     */
    radius?: number;
    /**
     * ç­åå¾çæ¸ååºé´
     */
    gradient?: { [key: string]: string };
    /**
     * ç­åå¾éæåº¦æ°ç»ï¼åå¼èå´[0,1]ï¼0è¡¨ç¤ºå®å¨éæï¼1è¡¨ç¤ºä¸éæ
     * é»è®¤ï¼[0,1]
     */
    opacity?: [number, number];
    /**
     * æ¯æçç¼©æ¾çº§å«èå´ï¼åå¼èå´[3-18]
     * é»è®¤ï¼[3,18]
     */
    zooms?: [number, number];

    rejectMapMask?: boolean;
    visible?: boolean;
    radiusUnit?: string;
    blur?: number;
    zIndex?: number;
    renderOnZooming?: boolean;
    ['3d']?: {
      heightScale?: number;
      heightBezier?: number[];
      gridSize?: number;
      drawGridLine?: boolean;
    };
  }
  export interface Data {
    /**
     * ç»åº¦
     */
    lng: number;
    /**
     * ç»´åº¦
     */
    lat: number;
    /**
     * æé
     */
    count: number;
  }
  export interface DataSet {
    /**
     * æéçæå¤§å¼
     */
    max?: number;
    /**
     * åæ æ°æ®é
     */
    data: Data[];
  }
}

@Injectable()
export class AmapHeatmapService implements Getter<any> {
  private heatmap: any;
  private heatmap$ = new ReplaySubject<any>(1);

  constructor(
    private amaps: AMapService,
    private plugin: PluginLoaderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  /**
   * è·åç­åå¾
   */
  get() {
    return this.heatmap$.asObservable();
  }

  /**
   * åå»ºç­åå¾ AMap.Heatmap
   * @param options éé¡¹
   */
  create(options: AMapHeatmap.Options) {
    return zip(this.amaps.get(), this.plugin.load('AMap.Heatmap')).pipe(
      map(([m]) => {
        this.heatmap = this.ngZone.runOutsideAngular(() => new AMap.Heatmap(m, options));
        this.logger.d(TAG, 'new Heatmap created.');
        this.heatmap$.next(this.heatmap);
        this.heatmap$.complete();
        return this.heatmap;
      }),
    );
  }

  /**
   * éæ¯ç­åå¾
   */
  destroy() {
    this.get().subscribe(heatmap => {
      heatmap.setMap(null);
      this.logger.d(TAG, 'Heatmap destroyed.');
      this.heatmap = null;
    });
  }
}
